import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row'
  },
  refresh: {
    marginRight: 16
  }
}))
export default useStyles
